import { getLongDate, getLongDateTime, getTextDuration, getLongUTCDateTime } from "../../../services/dateService";

export const DateFormatter = (params) => {
  return params.value && getLongDate(params.value);
};

export const DateTimeFormatter = (params) => {
  return params.value && getLongDateTime(params.value);
};

export const UTCDateTimeFormatter = (params) => {
  return params.value && getLongUTCDateTime(params.value);
};

export const DurationFormatter = (params) => {
  return params.value && getTextDuration(params.value);
};